import { cva } from 'class-variance-authority';

const buttonHierarchy = {
  primary: [
    'bg-tertiary-button-gradient text-white after:rounded-xl dark:bg-primary-button-default dark:text-buttonText-primary dark:border-gradient-primary-button-stroke',
    'hover:bg-tertiary-button-gradient-hover dark:hover:bg-primary-button-hover',
    'bg-gray-400 text-gray-50 dark:text-buttonText-linkGrayDisabled dark:disabled:bg-primary-100',
  ],
  secondary: [
    'bg-white/[.05] text-buttonText-secondary border-gradient-secondary-button-stroke after:rounded-xl dark:text-white',
    'hover:bg-white/10',
    'disabled:text-gray-600',
  ],
  tertiary: ['bg-black text-white dark:bg-gray-700', 'hover:bg-gray-900', 'disabled:bg-gray-400 disabled:text-gray-50'],
  linkGray: [
    'text-buttonText-linkGray dark:text-white',
    'hover:text-buttonText-linkGrayHover dark:hover:text-primary-100',
    'group-hover:text-buttonText-linkGrayHover dark:group-hover:text-primary-100',
    'disabled:text-gray-300 dark:disabled:text-gray-500',
  ],
  linkColor: [
    'text-buttonText-linkColor dark:text-primary-50',
    'hover:text-buttonText-linkColorHover dark:hover:text-primary-100',
    'disabled:text-buttonText-linkColorDisabled dark:disabled:text-primary-700',
  ],
  linkLight: [
    'text-buttonText-lightColor dark:text-primary-1000',
    'hover:text-buttonText-lightColor dark:hover:text-primary-1100',
    'disabled:text-buttonText-lightColor dark:disabled:text-primary-1100',
  ],

  // NEW: palette-less “custom” style driven by CSS variables
  // (keeps spacing, radius and focus behavior identical)
  custom: [
    'text-[var(--btn-text)] border border-[var(--btn-border)]',
    // background is set either as solid or gradient via extra classes from component
    'focus:ring-2 ring-offset-2 ring-[var(--btn-focus)]',
  ],
} as const;

const buttonVariants = cva(
  [
    'group',
    'md:w-fit',
    'inline-flex items-center justify-center gap-2',
    'text-md font-semibold',
    'size-fit rounded-lg',
    'transition-colors duration-200',
    'disabled:cursor-not-allowed',
    'focus-outline-primary',

    '[--btn-border:transparent] [--btn-focus:#22d3ee] [--btn-text:#101828]',
    '[--btn-bg-hover:transparent] [--btn-bg:transparent]',
    '[--btn-from:transparent] [--btn-to:transparent]',
    '[--btn-hfrom:transparent] [--btn-hto:transparent]',
  ],
  {
    variants: {
      hierarchy: buttonHierarchy as unknown as Record<string, string[]>,
      forceSmallerSize: { true: 'button-force-small', false: 'button-size' },
    },
    compoundVariants: [{ hierarchy: ['linkGray', 'linkColor', 'linkLight'], class: '!p-0' }],
    defaultVariants: { hierarchy: 'primary' },
  },
);

export const buttonHierarchyOptions = Object.keys(buttonHierarchy);
export default buttonVariants;
